import React from "react";
import AssignedUsersGridSingleExpandExample from "./AssignedUsersGridSingleExpandExample";

export default function AssignedUsersGridSingleExpandTestPage() {
  return (
    <div style={{ padding: 40 }}>
      <h2>AssignedUsersGrid Single Expand Test Page</h2>
      <AssignedUsersGridSingleExpandExample />
    </div>
  );
}
